<div (click)="playUrl()"
     class="absolute top-0 left-0 h-full w-full z-30 cursor-pointer flex">
  <audio #audioElementRef (ended)="onEnded()" (pause)="onPause()" (play)="onPlay()"
         [ngClass]="{'hidden': !showAudio()}"
         class="audio-player" controls>
    <source [src]="audioUrl" type="audio/mp3">
    Your browser does not support the audio element.
  </audio>
</div>
